import React, { useEffect, useState } from "react";
import { useTranslation } from "@emisgroup/acp-application-intl";
import { useDispatch, useSelector } from "react-redux";
import { Environments } from "@emisgroup/cohort-builder-kit";
import { IRootState } from "../../../../../reducer/CombineReducer";
import { BandsTypes } from "../../Banding/Types";
import { BandFormTypes } from "../OutputMappingAgeForm/Types";
import { FetchBandingDetails } from "../Script";
import { useUser } from "../../../../../AuthContext";
import { OutputMappingGenderFormView } from "./OutputMappingGenderForm.view";

/**
 * Responsible for gender popup logic
 */
export const OutputMappingGenderForm: React.FC = () => {
  const dispatch = useDispatch();
  const { t: translate } = useTranslation();
  const outputConfig = useSelector((state: IRootState) => state.outputConfig);
  const configId = outputConfig.selectedOutputConfig.id;
  const [data, setData] = useState<BandFormTypes[]>([]);
  const { user } = useUser();
  const env = process.env.APP_TARGET_ENV as Environments;

  useEffect(() => {
    (async (): Promise<void> => {
      const res = await FetchBandingDetails(
        configId,
        BandsTypes.GENDER.toLowerCase(),
        translate,
        dispatch,
        env,
        user?.token
      );
      setData(res);
    })();
  }, []);

  return (
    <OutputMappingGenderFormView
      configId={configId}
      data={data}
    />
  );
};
